import dynamic from "next/dynamic";
const FrequentlyAskedQuestionsPricingComponent = dynamic(()=>import("./frequently-asked-questions-pricing-component"));
import FrequentlyAskedQuestionsPricingConfig from "./frequently-asked-questions-pricing-config";
import FrequentlyAskedQuestionsPricingAdvancedConfig from "./frequently-asked-questions-pricing-advanced-config";
export default {
    FrequentlyAskedQuestionsPricingComponent,
    FrequentlyAskedQuestionsPricingConfig,
    FrequentlyAskedQuestionsPricingAdvancedConfig
};
